(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/co-op-play/assets/javascripts/helpers/utils.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/co-op-play/assets/javascripts/helpers/utils.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const assign = function (target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  return Object.assign(target, ...sources.map(x => Object.fromEntries(Object.entries(x).filter(_ref => {
    let [, value] = _ref;
    return value !== undefined;
  }))));
};
const merge = (target, source) => source.reduce((acc, obj) => {
  const index = acc.findIndex(_ref2 => {
    let {
      id
    } = _ref2;
    return obj.id === id;
  });

  if (index < 0) {
    return [...acc, obj];
  }

  const games = [...acc[index].games];
  obj.games.forEach(game => {
    const id = game.activatedDrawId;
    const gameIndex = games.findIndex(g => g.activatedDrawId === id);
    if (gameIndex !== -1) {
      games[gameIndex] = assign({}, games[gameIndex], game);
    } else {
      games.push(game);
    }
  });
  acc[index] = _objectSpread(_objectSpread({}, assign({}, acc[index], obj)), {}, {
    games
  });
  return acc;
}, target);
setGlobal('svs.components.marketplaceShared.coOpPlay.helpers.utils', {
  assign,
  merge
});

 })(window);